import {createGlobalStyle} from 'styled-components';
import HansonBold from './fonts/Hanson-Bold.ttf';
import OpenSansBold from './fonts/OpenSans-Bold.ttf';
import OpenSans from './fonts/OpenSans-Regular.ttf';

const GlobalStyles = createGlobalStyle`


    @font-face {
      font-family: 'Hanson Bold';
      src: local('Hanson Bold'), local('HansonBold'), url(${HansonBold}) format('truetype');
      font-weight: 200;
      font-style: normal;
    }

    @font-face {
        font-family: 'Open Sans Bold';
      src: local('Open Sans Bold'), local('OpenSans Bold'), local('OpenSansBold'), url(${OpenSansBold}) format('truetype');
      font-weight: 200;
      font-style: normal;
    }

    @font-face {
      font-family: 'Open Sans';
      src: local('Open Sans'), local('Open Sans Regular'), local('OpenSans-Regular'), url(${OpenSans}) format('truetype');
      font-weight: 200;
      font-style: normal;
    }

    .grid-container {
      display: grid;
  }

  .grid-container--fill {
      grid-template-columns: repeat(auto-fill, minmax(100px, 1fr));
  }

  .grid-container--fit {
      grid-template-columns: repeat(auto-fit, minmax(100px, 1fr));
  }



    pre{
      color: #FFFFFF;
    }

    .ant-layout * {
      color: #ffffff;
    }

  .ant-input-password-icon,
  .ant-input-suffix,
  .ant-picker-suffix{
    color: #d9d9d9 !important;
  }

  .ant-input,
  .ant-picker-input,
  .ant-select-multiple,
   .ant-select {
    background: none !important;
    font-family: 'Hanson Bold';
    font-weight: normal;
  }



  .ant-picker-input > input {
    color: #ffffff !important;
  }

  .ant-picker-cell-in-view.ant-picker-cell-selected .ant-picker-cell-inner {
    background: #FF6633 !important;
  }

  .ant-menu-horizontal > .ant-menu-item-selected .active {
    color: #FF6633 !important;
  }

  * {
    box-sizing: border-box;
    margin: 0;
    padding: 0;
  }

  html, body {
    color: ${props => props.theme.color || '#fafafa'};
    font-family: ${props =>
      props.theme.typography?.fontFamily?.body || "'Open Sans', 'Inter', system-ui, sans-serif"};
    background-color: ${props => props.theme.background || '#0a0a0a'};
    --antd-wave-shadow-color: ${props =>
      props.theme.colors?.secondary?.[500] || '#f97316'} !important;

    margin: 0;
    padding: 0;
    width: 100%;
    max-width: 100vw;
    min-height: 100vh;

    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    scroll-behavior: smooth;

    overflow-x: hidden;
  }

  #root {
    width: 100%;
    max-width: 100vw;
    min-height: 100vh;
    background-color: ${props => props.theme.background || '#0a0a0a'};
    margin: 0;
    padding: 0;
  }

  .ant-layout {
    background: transparent !important;
    width: 100% !important;
    max-width: 100vw !important;
    margin: 0 !important;
    padding: 0 !important;
  }

  .ant-layout-content {
    background: transparent !important;
    width: 100% !important;
    max-width: 100vw !important;
    margin: 0 !important;
    padding: 0 !important;
  }

  .ant-layout-header {
    background: transparent !important;
    width: 100% !important;
    max-width: 100vw !important;
    padding: 0 !important;
  }

  .ant-layout-footer {
    background: transparent !important;
    width: 100% !important;
    max-width: 100vw !important;
    padding: 0 !important;
  }

  h1,h2,h3,h4,h5,
  .ant-btn {
     font-family: ${props =>
       props.theme.typography?.fontFamily?.heading ||
       "'Hanson Bold', 'Inter', system-ui, sans-serif"};
     color: ${props => props.theme.colors?.neutral?.[50] || '#fafafa'} !important;
  }

  .ant-menu-horizontal > .ant-menu-item-selected {
    border-bottom: #FF6633 !important;
  }

  .ant-input-affix-wrapper > input.ant-input {
    color: ${props => {
      return props.theme.color;
    }};
  }

  .error {
    color: #FF0000;
    padding-bottom: 10px;
  }
`;

export default GlobalStyles;
